import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Grid } from './../../../../themes/default';
import { Section, Content } from './../../../../components/includes/container';
import { ToolbarPrimary } from './../../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../../components/includes/breadcrumb';
import { CardDefault } from './../../../../components/includes/card';
import { Dropdown } from './../../../../components/includes/dropdown';

class Report__Wheel extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      data: {
        datasets: [
          {
            label: 'Registros',
            type: 'line',
            data: [51, 65, 40, 49, 60, 37, 40],
            fill: false,
            borderColor: '#EC932F',
            backgroundColor: '#EC932F',
            pointBorderColor: '#EC932F',
            pointBackgroundColor: '#EC932F',
            pointHoverBackgroundColor: '#EC932F',
            pointHoverBorderColor: '#EC932F',
            yAxisID: 'y-axis-2'
          },
          {
            type: 'bar',
            label: 'Jugadas',
            data: [200, 185, 590, 621, 250, 400, 95],
            fill: false,
            backgroundColor: '#1463d9',
            borderColor: '#1463d9',
            hoverBackgroundColor: '#2775eb',
            hoverBorderColor: '#2775eb',
            yAxisID: 'y-axis-1'
          }
        ],
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July']
      },
      options: {
        elements: {
          line: {
            fill: false
          }
        },
        scales: {
          xAxes: [
            {
              display: true,
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              type: 'linear',
              display: true,
              position: 'left',
              id: 'y-axis-1',
              gridLines: {
                display: false
              }
            },
            {
              type: 'linear',
              display: true,
              position: 'right',
              id: 'y-axis-2'
            }
          ]
        }
      }
    };
  }

  componentDidMount(){

  }

  render() {

    return (
      <Section>

        <ToolbarPrimary title="Reportes"/>
        <BreadcrumbItem to='/reports'>Reportes</BreadcrumbItem>
        <BreadcrumbItem to='/reports/wheel'>Ruleta</BreadcrumbItem>

        <Content>

          <Grid container spacing={24}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <CardDefault
                title="Cordoba - Poeta Lugones"
                action={
                  <Dropdown items={
                      [
                        { label: 'Exportar', event: () => { this.handleExportToCSV() } }
                      ]
                    }
                  />
                }
              >
              <Bar data={this.state.data} options={this.state.options} height={80}/>
              </CardDefault>
            </Grid>
          </Grid>

        </Content>

      </Section>
    )
  }

};

export default Report__Wheel;
